/**
 * Área FICHA · E-MAIL ATENDIMENTO: os modelos de e-mail vinculados aos produtos do lead, e o envio.
 *
 * Cobre a leitura dos modelos (`admin.html:9650` a `9653`) e o envio pela Edge Function
 * `enviar-email-atendimento` (`9726` a `9732`). O "Baixar" do modelo é um download do Storage
 * (`9676`), em `ficha-arquivos.ts`, e a frase de cada erro de envio vem de `mensagemErroEnvioEmail`,
 * no núcleo do pacote (`erros.ts`), portada palavra por palavra.
 *
 * O SEGREDO DO SERVIDOR DE E-MAIL NÃO PASSA POR AQUI: quem envia é a função, e ela lê o destinatário
 * e o arquivo do banco (`9722` a `9725`). O corpo leva só identificadores.
 */

// Tudo que uma área usa vem do núcleo, e de mais lugar nenhum (ver PADRAO.md).
import {
  clienteDe,
  executar,
  invocarFuncao,
  type FonteDeDados,
  type LinhaParametrosProdutoEmail,
  type Resultado,
} from '../nucleo.js';

/**
 * Lê os modelos de e-mail dos produtos do lead, já na chave de parâmetro.
 * Legado: `admin.html:9650` a `9653`, `sb.from('parametros_produto_email').select('*')
 * .in('produto', produtosParamClienteAtual)`.
 *
 * Sem ordem na consulta, como no legado: a lista sai na ordem que o banco devolver.
 */
export function lerModelosDeEmail(
  fonte: FonteDeDados,
  produtosParam: readonly string[],
): Promise<Resultado<readonly LinhaParametrosProdutoEmail[] | null>> {
  return executar<readonly LinhaParametrosProdutoEmail[] | null>(
    clienteDe(fonte).from('parametros_produto_email').select('*').in('produto', [...produtosParam]),
  );
}

/** O corpo que o legado manda (`admin.html:9727` a `9731`): só identificadores. */
export interface PedidoDeEnvio {
  readonly user_id: string;
  readonly lead_id: number | null;
  readonly produto: string;
}

/** O que a função devolve em 2xx; o legado lê só `destinatario`, para o `title` (`9746`). */
export interface RespostaDoEnvio {
  readonly destinatario?: string;
}

/**
 * Pede o envio do modelo de e-mail do produto à cliente.
 * Legado: `admin.html:9726`, `sb.functions.invoke('enviar-email-atendimento', { body })`.
 *
 * Status fora de 2xx volta em `erro` com `status` e `corpo` já lidos, que é o que a frase do
 * legado (`mensagemErroEnvioEmail`) precisa.
 */
export function enviarEmailAtendimento(
  fonte: FonteDeDados,
  pedido: PedidoDeEnvio,
): Promise<Resultado<RespostaDoEnvio | null>> {
  // As três chaves do legado, e nenhuma a mais: e-mail e caminho do arquivo a função lê do banco.
  return invocarFuncao<RespostaDoEnvio | null>(fonte, 'enviar-email-atendimento', {
    body: { user_id: pedido.user_id, lead_id: pedido.lead_id, produto: pedido.produto },
  });
}
